import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import SweetAlert from 'sweetalert2';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, Customer, CustomerList, changepwd, Search, Filter, Area, Status, Export, Import, importFile, customerImportTitle, customerImportTableTitle, customerDueImportTitle, AddCustomer, AddServiceAccount } from '../../../Constant';
import { deleteCustomer, viewCustomer, viewCustomerRole, getArea, getstatscount, changecutomerstatus, publicSampleDownloadCustomer, getstatscountRole, getAreaRole, changecutomerstatusRole, deleteCustomerRole, publicSampleDownloadCustomerDue, postCustomerImportDue } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Popup from '../../Common/Popup/popup';
import ChangePwd from './ChangePwd';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import Widgets from '../../Common/Progress/Widgets';
import moment from 'moment';
import ImportPopUp from '../../Common/Import/ImportPop';
import PopupImport from '../../Common/Popup/popupImport';
import Transparentspinner from '../../Common/Loader/Transparentspinner';
import ImportDuePopUp from '../../Common/Import/ImportDuePop';
import WidgetSmall from '../../Common/Progress/WidgetSmall';
import { CustomerColumns } from '../ColumnHeader/Header';

const CustomerListContainer = () => {
    const [spinnerTrans, setspinnerTrans] = useState(false);
    const changepwdtitile = <span className='billerqColor bolder '>
        <h3>{changepwd}</h3>
    </span>
    const fileImport = <span className='billerqColor bolder '>
        <h3>{importFile}</h3>
    </span>
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [customerLists, setCustomerList] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [modal, setModal] = useState(false);
    const [modalImport, setModalImport] = useState(false);
    const [modalImportDue, setModalImportDue] = useState(false);
    const [customerId, setcustomerId] = useState(null)
    const [dateRange, setDateRange] = useState([null, null]);
    const [apiArea, setapiArea] = useState([]);
    const [startDate, endDate] = dateRange
    const [staticwidgets, setstaticwidgets] = useState([])
    const isSearched = useRef(null);
    const isArea = useRef(null);
    const cust_status = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [dropdownOpenMenu, setDropdownOpenMenu] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const [filters, setFilters] = useState({
        searchKey: '',
        areaFilter: '',
        cust_status_Filter: '',
        start_date: '',
        end_date: ''
    });
    const [importDrpodown, setimportDrpodown] = useState(false);
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });

    const statusOptions = [
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
        { value: "suspended", label: "Suspended" },
    ];

    useEffect(() => {
        fetchCustomer(1);
        areaData();
        getwidgetsdata();
    }, []);

    const toggleImport = () => setimportDrpodown(!importDrpodown);
    const toggleDropdownMenu = () => setDropdownOpenMenu(!dropdownOpenMenu);


    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchCustomer(currentPage, perPage, filters.searchKey, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, column.id, newOrder);
    };

    const handleModal = (id) => {
        setModal(!modal);
        setcustomerId(id);
    }

    const handleModalImport = () => {
        setModalImport(!modalImport);
    }

    const handleModalImportDue = () => {
        setModalImportDue(!modalImportDue);
    }

    const handleImportCustomerLog = () => {
        const navigatetoLog = `${process.env.PUBLIC_URL}/customers/customer/imported-log-list`;
        navigate(navigatetoLog)
    }

    const handleImportCustomerDueLog = () => {
        const navigatetoLog = `${process.env.PUBLIC_URL}/customers/customer/imported-due-log-list`;
        navigate(navigatetoLog)
    }

    const getwidgetsdata = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getstatscount : getstatscountRole);
        if (data.status === true) {
            setstaticwidgets(data.data);
        } else {
            handleApiError(data.status);
        }
    }

    const handleStatusChange = async (id, newStatus, confirmationTitle) => {
        SweetAlert.fire({
            title: `Are you sure you want to ${confirmationTitle}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: confirmationTitle,
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        }).then(async (result) => {
            setspinnerTrans(true);
            if (result.value) {
                const postRequest = { customer_id: id, status: newStatus };
                const statusChange = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? changecutomerstatus : changecutomerstatusRole, postRequest);
                if (statusChange.status === 200) {
                    if (statusChange.data.status === true) {
                        toast.success(statusChange.data.message);
                        fetchCustomer(currentPage, perPage, filters.searchKey, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, sortConfig.column, sortConfig.order);
                        setspinnerTrans(false)
                    } else {
                        toast.error(statusChange.data.message);
                        setspinnerTrans(false)
                    }
                } else {
                    handleApiError(statusChange.status);
                }
            }
            setspinnerTrans(false)

        });
    };


    const handlestatusArchive = (id, row) => {
        SweetAlert.fire({
            title: 'Are you sure you want to Archive?',
            text: 'Archiving the customer will results : Service Account being disconnected ',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Archive',
            cancelButtonText: 'Cancel',
            reverseButtons: true
        }).then(async (result) => {
            setspinnerTrans(false)
            if (result.value) {
                const postRequest = {
                    customer_id: id,
                }
                const statusChange = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? deleteCustomer : deleteCustomerRole, postRequest);
                if (statusChange.status === 200) {
                    if (statusChange.data.status === true) {
                        toast.success(statusChange.data.message);
                        fetchCustomer(currentPage, perPage, filters.searchKey, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, sortConfig.column, sortConfig.order);
                    } else {
                        setspinnerTrans(false);
                        toast.error(statusChange.data.message);
                    }
                } else {
                    handleApiError(statusChange.status);
                }
            }
            setspinnerTrans(false)
        });
    };

    const fetchCustomer = async (page, size = perPage, searchKey = '', start_date = '', end_date = '', areaFilter = '', cust_status_Filter = '', sortBy = '', sortOrder = '') => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewCustomer +
            `?page=${page}&page_length=${size}&search=${searchKey}&start_date=${start_date}&end_date=${end_date}&area_id=${areaFilter}&status=${cust_status_Filter}&sort_by=${sortBy}&sort_order=${sortOrder}` :
            viewCustomerRole + `?page=${page}&page_length=${size}&search=${searchKey}&start_date=${start_date}&end_date=${end_date}&area_id=${areaFilter}&status=${cust_status_Filter}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setCustomerList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    subscriber_id: <span>{e.subscriber_id}</span>,
                    Lco: e.lco_no,
                    name: e.name,
                    Mobile: "+" + e.country_code + " " + e.mobile,
                    Address: e.address.replace(/"/g, "" || ""),
                    Route: e.route_no,
                    Area: e.area_name,
                    Type: e.customer_type,
                    Date: e.join_date,
                    id: e.id,
                    Status: e.status,
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const exportCustomerExcel = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewCustomer + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &start_date=${filters?.start_date ? filters.start_date : ''}&end_date=${filters?.end_date ? filters.end_date : ''}
            &area_id=${filters?.areaFilter ? filters.areaFilter : ''}
            &status=${filters?.cust_status_Filter ? filters.cust_status_Filter : ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`
            : viewCustomerRole + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &start_date=${filters?.start_date ? filters.start_date : ''}&end_date=${filters?.end_date ? filters.end_date : ''}
            &area_id=${filters?.areaFilter ? filters.areaFilter : ''}
            &status=${filters?.cust_status_Filter ? filters.cust_status_Filter : ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.data.map(({ subscriber_id, name, status, mobile, address, country_code }) => ({ Customer_Id: subscriber_id, Name: name, Mobile: `+${country_code} ${mobile}`, Address: address.replace(/"/g, ''), Status: status, }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Customer Data');
            XLSX.writeFile(wb, 'customer_data.xlsx');
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const exportCustomerPdf = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewCustomer + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &start_date=${filters?.start_date ? filters.start_date : ''}&end_date=${filters?.end_date ? filters.end_date : ''}
            &area_id=${filters?.areaFilter ? filters.areaFilter : ''}
            &status=${filters?.cust_status_Filter ? filters.cust_status_Filter : ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`
            : viewCustomerRole + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &start_date=${filters?.start_date ? filters.start_date : ''}&end_date=${filters?.end_date ? filters.end_date : ''}
            &area_id=${filters?.areaFilter ? filters.areaFilter : ''}
            &status=${filters?.cust_status_Filter ? filters.cust_status_Filter : ''}&sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.data.map(({ subscriber_id, name, mobile, address, status }, index) => ({ Sl: index + 1, subscriber_id, name, mobile, address, status }));
        if (response.status === true) {
            const doc = new jsPDF();
            const heading = "Customer's list";
            doc.setFontSize(18);
            doc.setFont("helvetica", "bold");
            doc.text(heading, 14, 22);
            const columns = ["Sl", "Customer Id", "Name", "Mobile", "Address", "Status",];
            const rows = dataToExport.map(({ subscriber_id, name, mobile, address, status }, index) => [index + 1, subscriber_id, name, mobile, address, status]);
            doc.autoTable({
                head: [columns],
                body: rows,
                columnStyles: {
                    0: { cellWidth: 10 },
                    1: { cellWidth: 25 },
                    2: { cellWidth: 30 },
                    4: { cellWidth: 40 }
                },
                styles: { fontSize: 10 },
                headStyles: { fillColor: [100, 150, 200] },
            });
            doc.save("customer_list.pdf");
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };


    const handlePageChange = page => {
        fetchCustomer(page, perPage, filters.searchKey, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomer(page, newPerPage, filters.searchKey, filters.start_date, filters.end_date, filters.areaFilter, filters.cust_status_Filter, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const handleFilter = async (e) => {
        e.preventDefault();
        const searchKey = isSearched.current.value;
        const areaFilter = isArea?.current?.value;
        const cust_status_Filter = cust_status.current.value;
        const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : '';
        const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : '';
        setFilters({
            searchKey,
            areaFilter,
            cust_status_Filter,
            start_date,
            end_date
        });
        fetchCustomer(currentPage, perPage, searchKey, start_date, end_date, areaFilter, cust_status_Filter, sortConfig.column, sortConfig.order);
    };

    const areaData = async () => {
        const data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? getArea : getAreaRole);
        if (data.status === true) {
            setapiArea(data.data);
        } else {
            handleApiError(data.status);
        }
    };


    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={Customer} parent="Customers" title={Customer} />
            <WidgetSmall details={staticwidgets} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className='my-4'>
                        <H3>{CustomerList}</H3>
                    </div>
                    <div style={{ display: 'flex' }} className='d-none d-sm-block'>
                        <CardBody className="dropdown-basic d-flex flex-wrap gap-2 justify-content-end" style={{ borderRadius: '5px' }}>
                            {(authState.userRole === 1 || authState.permissions.includes('store-customer')) &&
                                <Link to={`${process.env.PUBLIC_URL}/Customers/customer-add`} className="btn btn-primary mr-4" style={{ marginLeft: '10px' }}>{AddCustomer}</Link>
                            }
                            {(authState.userRole === 1 || authState.permissions.includes('store-customer')) &&
                                <Link to={`${process.env.PUBLIC_URL}/customers/add-service-account`} className="btn btn-primary mr-4 " >{AddServiceAccount}</Link>
                            }
                            {
                                (authState.userRole === 1 || authState.permissions.includes('import-customer')) &&
                                <Dropdown className='m-0 ' isOpen={importDrpodown} toggle={toggleImport}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Import} <i className="icofont icofont-arrow-down"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => handleModalImport()}><i className="fa fa-file-text-o me-2"></i> Import Customer</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => handleImportCustomerLog()}><i className="fa fa-list-alt me-2"></i> Imported Customer Logs</DropdownItem>
                                        {/* <DropdownItem style={toggleStyle} onClick={() => handleModalImportDue()}><i className="fa fa-file-text-o me-2"></i> Import Customer Dues</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => handleImportCustomerDueLog()}><i className="fa fa-list-alt me-2"></i> Imported Customer Due Logs</DropdownItem> */}
                                    </DropdownMenu>
                                </Dropdown>
                            }
                            {
                                (authState.userRole === 1 || authState.permissions.includes('customer-export')) &&
                                <Dropdown className='m-0' isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                        {Export} <i className="icofont icofont-arrow-up"></i>
                                    </DropdownToggle>
                                    <DropdownMenu container="body">
                                        <DropdownItem style={toggleStyle} onClick={() => exportCustomerExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                        <DropdownItem style={toggleStyle} onClick={() => exportCustomerPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                    </DropdownMenu>
                                </Dropdown>
                            }
                        </CardBody>
                    </div>
                    <div className='d-block d-sm-none'>
                        <CardBody className="dropdown-basic d-flex flex-wrap gap-2 justify-content-end" style={{ borderRadius: '5px' }}>

                            <Dropdown isOpen={dropdownOpenMenu} toggle={toggleDropdownMenu}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }}>
                                    <i className="fa fa-ellipsis-v"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body" style={{ gap: '40px' }}>

                                    <DropdownItem className='mt-3'>

                                        {(authState.userRole === 1 || authState.permissions.includes('store-customer')) &&
                                            <Link to={`${process.env.PUBLIC_URL}/Customers/customer-add`} className=" mr-4" style={{ marginLeft: '10px', color: 'black' }}>{AddCustomer}</Link>
                                        }
                                    </DropdownItem>
                                    <DropdownItem >

                                        {(authState.userRole === 1 || authState.permissions.includes('store-customer')) &&
                                            <Link to={`${process.env.PUBLIC_URL}/Customers/customer-add`} className="mr-4" style={{ marginLeft: '10px', color: 'black' }}>{AddCustomer}</Link>
                                        }
                                    </DropdownItem>
                                    <DropdownItem>

                                        {(authState.userRole === 1 || authState.permissions.includes('store-customer')) &&
                                            <Link to={`${process.env.PUBLIC_URL}/customers/add-service-account`} className="mr-4 " style={{ marginLeft: '10px', color: 'black' }} >{AddServiceAccount}</Link>
                                        }
                                    </DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportCustomerExcel()}><i className="fa fa-file-excel-o me-2"></i>Export to Excel</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportCustomerPdf()}><i className="fa fa-file-pdf-o me-2"></i>Export to Pdf</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => handleModalImport()}><i className="fa fa-file-text-o me-2"></i> Import Customer</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => handleImportCustomerLog()}><i className="fa fa-list-alt me-2"></i> Imported Customer Logs</DropdownItem>

                                </DropdownMenu>
                            </Dropdown>
                        </CardBody>

                    </div>

                </CardHeader>
                <CardBody>
                    <span className=''>
                        <Form className="needs-validation" noValidate onSubmit={handleFilter}>
                            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                                <Col sm="12" md='5' lg='2'>
                                    <input className="form-control" placeholder={Search} type="text" ref={isSearched}
                                    />
                                </Col>
                                {/* <Col sm="12" md="5" lg='2' className="form-element">
                                    <select className="form-select" ref={isArea}>
                                        <option value="">{Area}</option>
                                        {apiArea.map((values, index) => (
                                            <option key={index} value={values.id}>{values.name}</option>
                                        ))}
                                    </select>
                                </Col> */}
                                <Col sm="12" md="5" lg='2' className="form-element">
                                    <select className="form-select" ref={cust_status}>
                                        <option value="">{Status}</option>
                                        {statusOptions.map((option, index) => (
                                            <option key={index} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </Col>
                                <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                    <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>

                    <div className="order-history table-responsive">
                        <DataTable
                            columns={CustomerColumns(authState, handleStatusChange, handlestatusArchive)}
                            data={customerLists}
                            // progressPending={loading}
                            pagination
                            paginationServer
                            defaultSortAsc
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                            highlightOnHover
                            pointerOnHover
                            onRowClicked={(row) => {
                                if (authState.userRole === 1 || authState.permissions?.includes('show-customer-profile')) {
                                    navigate(`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.id}`);
                                }
                            }}
                        />
                    </div>
                </CardBody>
            </Card>
            <PopupImport isOpen={modalImport} title={fileImport} toggler={handleModalImport} >
                <ImportPopUp
                    setModal={setModalImport}
                    sampleImportApi={publicSampleDownloadCustomer}
                    // postImportApi={postCustomerImport}
                    imporTitle={customerImportTitle}
                    tableTitle={customerImportTableTitle}
                    tablerenderFunc={fetchCustomer}
                    currentPage={currentPage}
                    perPage={perPage}
                />
            </PopupImport>
            <PopupImport isOpen={modalImportDue} title={fileImport} toggler={handleModalImportDue} >
                <ImportDuePopUp
                    setModalImport={setModalImportDue}
                    sampleImportApi={publicSampleDownloadCustomerDue}
                    postImportApi={postCustomerImportDue}
                    imporTitle={customerDueImportTitle}
                    tableTitle={customerImportTableTitle}
                    tablerenderFunc={fetchCustomer}
                    currentPage={currentPage}
                    perPage={perPage}
                />
            </PopupImport>
            <Popup isOpen={modal} title={changepwdtitile} toggler={handleModal} >
                <ChangePwd
                    customerId={customerId}
                    setModal={setModal}
                    fetchCustomer={fetchCustomer}
                />
            </Popup>
        </Fragment>
    );
};

export default CustomerListContainer;